export default "__VITE_ASSET__D6Tx7HoK__"